enum Align {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

enum AlignCommand {
  LEFT = 'align-dd-left',
  CENTER = 'align-dd-center',
  RIGHT = 'align-dd-right',
}

export { Align, AlignCommand }
